import { Route } from "react-router";
import appsComponentsAll from "./projects-handler/appsComponentsAll";

const projectsRoutesRender = (data) => {
    const { urlPage, element } = data;

    return(
      <Route path={`/projects/:${urlPage}`} element={appsComponentsAll[element]} key={urlPage} />
    )

}

export default projectsRoutesRender;